export const escapeAttribute = (value: string): string =>
  value
    .replaceAll('&', '&amp;')
    .replaceAll('"', '&quot;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll("'", '&#39;');

export function agentSharing(
  publicId: string,
  dashboardOrigin: string,
  apiBaseUrl: string,
  inline = false,
  demoBaseUrl?: string,
) {
  let demoUrl = new URL(`/demo/${encodeURIComponent(publicId)}`, dashboardOrigin).href;
  if (demoBaseUrl) {
    try {
      demoUrl = new URL(`/${encodeURIComponent(publicId)}`, demoBaseUrl).href;
    } catch {
      // Preserve usable legacy links if a deployment variable is malformed.
    }
  }
  const loader = new URL('/widget/v1/loader.js', dashboardOrigin).href;
  const targetId = `talk-chat-${publicId}`;
  const snippet = [
    ...(inline
      ? [`<div id="${escapeAttribute(targetId)}" style="width:100%;max-width:820px"></div>`]
      : []),
    '<script',
    `  src="${escapeAttribute(loader)}"`,
    `  data-agent-id="${escapeAttribute(publicId)}"`,
    `  data-api-base-url="${escapeAttribute(apiBaseUrl)}"`,
    ...(inline ? [`  data-target-id="${escapeAttribute(targetId)}"`] : ['  data-position="right"']),
    '  data-theme="light"',
    '  defer',
    '></script>',
  ].join('\n');
  return { demoUrl, snippet };
}

export function isDemoOrigin(currentOrigin: string, demoBaseUrl: string | undefined): boolean {
  if (!demoBaseUrl) return false;
  try {
    return new URL(currentOrigin).origin === new URL(demoBaseUrl).origin;
  } catch {
    return false;
  }
}
